import BaseModelAPI from '../BaseModelAPI';

export default class PickingStatusList extends BaseModelAPI {

	static entity = 'pickingstatuslist'
	static entityName = 'pickingstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
